export function dropColumn(str, ...columnNames) {
  let tableData;

  try {
    tableData = JSON.tryParse(str);
  } catch (error) {
    console.error("Error dropping column:", error);
    throw new Error("Invalid JSON format");
  }

  tableData = tableData.map((row) => {
    const newRow = { ...row };
    columnNames.forEach((columnName) => {
      delete newRow[columnName];
    });
    return newRow;
  });

  return JSON.stringify(tableData);
}
